export const locale = {
    lang: 'en',
    data: {
        LANDING_BANNER: {
            LAST_VIEWED: {
                TITLE: 'Get started!',
                SUBTITLE: 'Begin your home search and return here anytime to pick up where you left off.',
                BUTTON_TEXT: 'Find Your Home'
            },
            APPOINTMENTS: {
                TITLE: 'Want to see your future home?',
                SUBTITLE: 'Request viewing appointments with your agent, and return here to manage and organize your schedule.',
                BUTTON_TEXT: 'View Appointments'
            },
            MESSAGES: {
                TITLE: 'Have a question?',
                SUBTITLE: 'Send questions or comments to your agent about homes you love, and return here to see your unread messages.',
            }
        }
    }
};